<!-- <h1 mat-dialog-title>Got time for feedback? Your feedback would help us improve the app further.</h1> -->
<div mat-dialog-content>
  <app-feedback></app-feedback>
</div>
<div class="actions">
  <button mat-button [mat-dialog-close]="false" i18n>No, thanks</button>
  <!-- <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes, I do</button> -->
</div>
